import PasswordGate from './PasswordGate';

export default PasswordGate;
